import './quotes';
import './projects';
import './contentSlider';
